import { render, staticRenderFns } from "./menusConfig.vue?vue&type=template&id=390aed60&scoped=true&"
import script from "./menusConfig.vue?vue&type=script&lang=js&"
export * from "./menusConfig.vue?vue&type=script&lang=js&"
import style0 from "./menusConfig.vue?vue&type=style&index=0&id=390aed60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390aed60",
  null
  
)

export default component.exports